import React from 'react';
import { formatDate, DATE_WITH_SHORT_TIME_FORMAT } from '@utils/date';
import isEmpty from 'lodash/isEmpty';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';

export const RenderCell = props => (
  <span>
    {props.value && formatDate(props.value, DATE_WITH_SHORT_TIME_FORMAT)}
  </span>
);

export const RenderCellArray = props => (
  <span>
    {props.value &&
      props.value.length > 0 &&
      formatDate(
        props.value[props.value.length - 1],
        DATE_WITH_SHORT_TIME_FORMAT
      )}
  </span>
);

export const Method = (filter, row) => {
  return (
    isEmpty(filter.value) ||
    (filter.value.startDate.isBefore(row[filter.id]) &&
      filter.value.endDate.isAfter(row[filter.id]))
  );
};

// We have sorted ascending array of dates here
export const MethodArray = (filter, row) => {
  if (isEmpty(filter.value)) return true;

  const values = row[filter.id];
  if (values.length === 1)
    return (
      filter.value.startDate.isBefore(values[0]) &&
      filter.value.endDate.isAfter(values[0])
    );

  let start = 0,
    end = values.length - 1;
  while (start < end) {
    const ind = Math.floor((start + end + 1) / 2);
    if (filter.value.startDate.isAfter(values[ind]))
      if (start !== ind) start = ind;
      else return false;
    else if (filter.value.endDate.isBefore(values[ind]))
      if (end !== ind) end = ind;
      else return false;
    else return true;
  }

  return false;
};

export const SortArray = (a, b, desc) => {
  const aa = a && a.length > 0 ? a[a.length - 1] : null;
  const bb = b && b.length > 0 ? b[b.length - 1] : null;

  if (aa > bb) {
    return 1;
  }

  if (aa < bb) {
    return -1;
  }

  return 0;
};

export const Filter = ({ filter, onChange, hide }) => (
  <>
    <DateRangePicker
      showDropdowns
      onApply={(event, picker) =>
        onChange({
          startDate: picker.startDate,
          endDate: picker.endDate,
        })
      }
      key="daterange-picker"
    >
      <button
        className="btn btn-xs btn-default"
        style={{ padding: '8px 5px', fontSize: '10px' }}
      >
        {filter && !isEmpty(filter.value) ? (
          <span>
            {filter.value.startDate.format('D[/]M[/]YY')}
            &nbsp;-&nbsp;
            {filter.value.endDate.format('D[/]M[/]YY')}
          </span>
        ) : (
          'Выбрать'
        )}
      </button>
    </DateRangePicker>
    {!hide && (
      <button
        className="btn btn-default btn-xs pull-right"
        style={{ padding: '6.5px 5px' }}
        onClick={e => onChange({})}
        key="daterange-refresh"
      >
        <i className="fa fa-times" aria-hidden="true"></i>
      </button>
    )}
  </>
);
